import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './guard/auth.guard';

const routes: Routes = [
  {
    path:'auth',loadChildren:() => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path:'',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canActivate:[AuthGuard]

  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  }

]
@NgModule({
  imports:[RouterModule.forRoot(routes)],
  exports:[RouterModule]
})
export class AppRoutingModule {}
